import React from "react";
import { Box, Button, Divider, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import MovieIcon from "@mui/icons-material/Movie";
import { COLORS } from "./constants";
import { commonInputProps, inputSx, barePanelSx, primaryButtonSx, sectionSubtleSx, sectionTitleSx } from "./styles";
import { StorageBar } from "./StorageBar";
import { VideoLibrary } from "./VideoLibrary";
import Mp4StatusPanel from "../Mp4StatusPanel";

export function Mp4SchedulePanel({
  // uploadState is still read to disable Schedule mid-upload; the input ref and
  // the upload handlers moved out with the dropzone.
  uploadState,
  storageSummary, uploadedVideos, selectedVideoId, setSelectedVideoId, deleteVideo,
  handleSchedule, scheduledAt, setScheduledAt, schedulerBusy,
  axiosConfig, onDeleteJob
}) {
  return (
    <Box sx={barePanelSx}>
      <Stack direction="row" spacing={1} alignItems="center" mb={0.5}>
        <MovieIcon sx={{ color: COLORS.amber }} />
        <Typography sx={sectionTitleSx}>MP4 Scheduled Stream</Typography>
      </Stack>
      <Typography sx={{ ...sectionSubtleSx, mb: 2 }}>
        Upload MP4 videos once (up to 8 GB), then schedule them anytime.
      </Typography>

      {/* The upload target moved to the preview frame at the top of the page —
          see Mp4Dropzone. It is the same upload with the same state (both live
          in Home), just placed where the eye already is when this source is
          selected. What stays here is everything you do AFTER the file exists:
          storage, the library, scheduling and history. */}
      <Stack spacing={1.25} mt={2}>
        <StorageBar storage={storageSummary} />
        <VideoLibrary videos={uploadedVideos} selectedId={selectedVideoId}
          onSelect={setSelectedVideoId} onDelete={deleteVideo} />
      </Stack>

      <Box component="form" onSubmit={handleSchedule}>
        <Divider sx={{ borderColor: COLORS.border, my: 2 }} />
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ sm: "center" }}>
          <TextField
            {...commonInputProps} type="datetime-local" value={scheduledAt}
            onChange={(e) => setScheduledAt(e.target.value)}
            InputProps={{ startAdornment: (
              <InputAdornment position="start">
                <AccessTimeIcon sx={{ color: COLORS.muted, fontSize: 17 }} />
              </InputAdornment>
            )}}
            sx={{ ...inputSx, flex: 1 }}
          />
          <Button
            type="submit" startIcon={<EventAvailableIcon />} variant="contained"
            disabled={schedulerBusy || !selectedVideoId || uploadState.uploading}
            sx={{ ...primaryButtonSx, whiteSpace: "nowrap", flexShrink: 0 }}
          >
            {schedulerBusy ? "Scheduling…" : "Schedule MP4"}
          </Button>
        </Stack>
      </Box>

      <Divider sx={{ borderColor: COLORS.border, mt: 2.5, mb: 1.5 }} />
      <Mp4StatusPanel axiosConfig={axiosConfig} onDeleteJob={onDeleteJob} />
    </Box>
  );
}
